export { linkToShareAssignment as linkToOverviewShareAssignment } from "./routes/overview/routes/share/links";
export { linkToShareMultipleAssignment } from "./routes/overview/routes/shareMultiple/links";
export { linkToDeleteAssignment } from "./routes/assignment/routes/delete/links";
export { linkToAssignmentPage } from "./routes/assignment/links";
export { linkToShareAssignment } from "./routes/assignment/routes/share/links";
export { linkToAssignmentStudentResult } from "./routes/assignment/routes/user/links";
export { linkToAssignmentsOverviewPage } from "./routes/overview/links";
